import { defineAsyncComponent } from 'vue'

export default {
    path: '/links',
    name: 'links.index',
    meta: {
        label: 'Links',
        icon: 'fal fa-external-link-square fa-fw',
        location: 'sidebar-top',
        permission: 'manage-links',
        menuItem: defineAsyncComponent(() => import('./components/MenuItem.vue')),
    },
}
